import {
  CREATE_DISCOUNT_REQUEST,
  CREATE_DISCOUNT_SUCCESS,
  CREATE_DISCOUNT_FAIL,
  LIST_DISCOUNTS_REQUEST,
  LIST_DISCOUNTS_SUCCESS,
  LIST_DISCOUNTS_FAIL,
  CREATE_DISCOUNT_RESET,
  DISCOUNT_DETAILS_REQUEST,
  DISCOUNT_DETAILS_SUCCESS,
  DISCOUNT_DETAILS_FAIL,
  UPDATE_DISCOUNT_REQUEST,
  UPDATE_DISCOUNT_SUCCESS,
  UPDATE_DISCOUNT_FAIL,
  UPDATE_DISCOUNT_RESET,
  DELETE_DISCOUNT_REQUEST,
  DELETE_DISCOUNT_SUCCESS,
  DELETE_DISCOUNT_FAIL,
  DELETE_DISCOUNT_RESET,
} from '../constants/discountConstants';

export const discountCreateReducer = (state = { loading: false, discount: null }, action) => {
  switch (action.type) {
    case CREATE_DISCOUNT_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_DISCOUNT_SUCCESS:
      return { loading: false, discount: action.payload, success: true };
    case CREATE_DISCOUNT_FAIL:
      return { loading: false, error: action.payload, errors: action.errors };
    case CREATE_DISCOUNT_RESET:
      return { loading: false, discount: null, success: false, error: null };
    default:
      return state;
  }
};

export const discountsListReducer = (state = { loading: false, discounts: [] }, action) => {
  switch (action.type) {
    case LIST_DISCOUNTS_REQUEST:
      return { ...state, loading: true, error: null };
    case LIST_DISCOUNTS_SUCCESS:
      return { loading: false, discounts: action.payload };
    case LIST_DISCOUNTS_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_DISCOUNT_SUCCESS:
      // Optimistically remove deleted id from list
      return {
        ...state,
        discounts: Array.isArray(state.discounts) ? state.discounts.filter((d) => d._id !== action.payload) : state.discounts,
      };
    default:
      return state;
  }
};

export const discountDetailsReducer = (state = { loading: false, discount: null }, action) => {
  switch (action.type) {
    case DISCOUNT_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };
    case DISCOUNT_DETAILS_SUCCESS:
      return { loading: false, discount: action.payload };
    case DISCOUNT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const discountUpdateReducer = (state = { loading: false, success: false, error: null }, action) => {
  switch (action.type) {
    case UPDATE_DISCOUNT_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case UPDATE_DISCOUNT_SUCCESS:
      return { loading: false, success: true };
    case UPDATE_DISCOUNT_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_DISCOUNT_RESET:
      return { loading: false, success: false, error: null };
    default:
      return state;
  }
};

export const discountDeleteReducer = (state = { loading: false, success: false, error: null }, action) => {
  switch (action.type) {
    case DELETE_DISCOUNT_REQUEST:
      return { ...state, loading: true, error: null, success: false, id: action.meta?.id };
    case DELETE_DISCOUNT_SUCCESS:
      return { loading: false, success: true };
    case DELETE_DISCOUNT_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_DISCOUNT_RESET:
      return { loading: false, success: false, error: null };
    default:
      return state;
  }
};
